import { ProductOrderableFragment } from '@/core/api/graphql/forshawGraphqlApi.generated.ts'
import { Product } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'

function mapProductOrderableToProduct(
  product: ProductOrderableFragment,
): Product {
  return {
    id: product.id,
    name: product.name,
    price: product.price,
    unit: product.unit ?? null,
    photo: product.photo ?? null,
    code: product.code,
    erpCatalogName: product.erpCatalogName ?? '',
    caseQuantity: product.caseQuantity ?? null,
    palletQuantity: product.palletQuantity ?? null,
    category: product.category
      ? {
          id: product.category.id,
          name: product.category.name,
          code: product.category.code,
        }
      : null,
    group: product.group
      ? {
          id: product.group.id,
          name: product.group.name,
          code: product.group.code,
        }
      : null,
    speciesIds: product.speciesIds,
    isInPlan: false,
    salableProductId: null,
    unavailable: product.unavailable ?? false,
  }
}

export { mapProductOrderableToProduct }
